import React, { useEffect, useMemo, useState } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import I18n from '../../../../../components/shared/i18n/I18n.component';
import colors from '../../../../../config/colors';
import WorkingTimeReportDetailComponent from './WorkingTimeReportDetail.component';
import { i18nService } from '../../../../../services/i18n.service';
import { fetchClientWorkingTimeData, fetchClientCompareCompaniesData } from '../../../../../store/actions/clientWorkingTime.action';
import {
  getClientBarChartCompaniesData,
  getClientCompaniesCompareData,
    getClientCompaniesData,
    getClientExcelCompaniesData,
    getClientMiniCardData,
    getClientPieCompaniesData,
    getFooterTableClientCompaniesCompareData,
    getFooterTableClientCompaniesData,
} from '../../../../../store/selectors/clientWorkingTime.selector';
import { exportToExcel } from '../../../../../services/excel.service';
import { Snackbar } from '@material-ui/core';


const WorkingTimeReportDetailContainer = (props: any) => {
  console.log('props WorkingTimeReportDetailContainer: ', props);
    const { route, navigation } = props;
    const dispatch = useDispatch();
    
    const [resolvedClientNumber, setResolvedClientNumber] = useState<number | null>(null);
    const [resolvedData, setResolvedData] = useState<any>(null);
    const [resolvedId, setResolvedId] = useState<string | null>(null);
	const [resolvedUserId, setResolvedUserId] = useState<number | string | null>(null);
	const [resetKey, setResetKey] = useState(0);
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState('');
    
    useEffect(() => {
        let id = route?.params?.id;
        let data = route?.params?.data;
        let clientNum = data?.clientNumber;
		let user_id = data?.user_id;
        
        if (!clientNum) {
            try {
                const stored = sessionStorage.getItem('workingTimeReportDetailData');
                if (stored) {
                    const parsedData = JSON.parse(stored);
                    id = parsedData?.id;
                    data = parsedData?.data;
                    clientNum = data?.clientNumber;
					user_id = data?.user_id;
                }
            } catch (error) {
                console.error('Error reading from sessionStorage:', error);
            }
        }
        
        setResolvedId(id);
        setResolvedData(data);
        setResolvedClientNumber(clientNum);
		setResolvedUserId(user_id);
    }, [route?.params]);
    
    const clientNumber = resolvedClientNumber;
    const data = resolvedData;
    const id = resolvedId;
    
    const clientMiniCardData = useSelector(getClientMiniCardData);
    const companysTableData = useSelector(getClientCompaniesData);
	const companiesExcelData = useSelector(getClientExcelCompaniesData);
    const companyPieData = useSelector(getClientPieCompaniesData);
    const footerData = useSelector(getFooterTableClientCompaniesData);
    const footerCompareData = useSelector(getFooterTableClientCompaniesCompareData);

    const compareData = useSelector(getClientCompaniesCompareData);
    const barChartDataWithColors = useSelector(getClientBarChartCompaniesData);
    const barChartData = barChartDataWithColors;
    const companyColorMapping = barChartDataWithColors.colors;
    
    const [compareCriteria, setCompareCriteria] = useState<{
        period: 'monthly' | 'daily';
        criterias: { date_from: string; date_to: string; key: string }[];
        selectedTab: number;
    } | null>(null);
    
    const [menuMode, setMenuMode] = useState('month');
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();
    const [selectedPeriod, setSelectedPeriod] = useState<any>({
        type: 'month',
        value: currentMonth,
        label: `${currentMonth}/${currentYear}`
    });

    const CustomHeaderContent = ({mainText, subText, customStyle}: { mainText: any; subText: any; customStyle?: object;}) => (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ...customStyle }}>
        <div style={{ fontWeight: 'bold' }}>{mainText}</div>
        <div style={{ fontWeight: 'normal', fontSize: '0.85em' }}>
          {subText}
        </div>
      </div>
	);

    const timeRangeOptions = [
    { label: 'יום', value: 'day' },
    { label: 'שבוע', value: 'week' },
    { label: 'חודש', value: 'month' },
    { label: 'שנה', value: 'year' },
    //{ label: 'רב שנתי', value: 'multi-year' },
    ];

	const handleReset = () => {
		setResetKey(prev => prev + 1 );
	}

    const handleChange = (selectedOption) => {
        console.log('Selected:', selectedOption);
        setMenuMode(selectedOption.value);
        setSelectedPeriod(null);
    };

    const handleDateChange = (selection) => {
        console.log('Date selection changed:', selection);
        setSelectedPeriod(selection);

        
        switch (selection.type) {
            case 'day':
                // selection.value = { day, month, year, dateString }
                console.log('Fetching data for day:', selection.value.dateString);
                dispatch(fetchClientWorkingTimeData({
                    clientnumber: clientNumber,
					user_id: resolvedUserId,
                    period: 'daily',
                    date_from: selection.value.dateString,
                    date_to: selection.value.dateString,
                }));
                break;

            case 'week':
                // selection.value = { startDate, endDate }
                console.log('Fetching data for week:', selection.value.startDate, 'to', selection.value.endDate);
                dispatch(fetchClientWorkingTimeData({
                    clientnumber: clientNumber,
					user_id: resolvedUserId,
                    period: 'daily',
                    date_from: selection.value.startDate,
                    date_to: selection.value.endDate,
                }));
                break;

            case 'month':
                // selection.value = month number (1-12)
                const currentYear = new Date().getFullYear();
                console.log('Fetching data for month:', selection.value, 'year:', currentYear);
                dispatch(fetchClientWorkingTimeData({
                    clientnumber: clientNumber,
					user_id: resolvedUserId,
                    period: 'monthly',
                    year: currentYear,
                    month: selection.value,
                }));
                break;

            case 'year':
                // selection.value = year number
                console.log('Fetching data for year:', selection.value);
                dispatch(fetchClientWorkingTimeData({
                    clientnumber: clientNumber,
					user_id: resolvedUserId,
                    period: 'monthly',
                    year: selection.value,
                    // month is omitted for yearly data
                }));
                break;

            default:
                console.log('Unknown selection type');
        }
        

    };

    const handleCompareData = (params: {
        period: 'monthly' | 'daily';
        criterias: { date_from: string; date_to: string; key: string }[];
        selectedTab: number;
    }) => {
        setCompareCriteria(params);
        dispatch(fetchClientCompareCompaniesData({
            period: params.period,
            clientnumber: clientNumber,
			user_id: resolvedUserId,
            criterias: params.criterias,
            selectedTab: params.selectedTab,
        }));
    };

    // Hebrew month names
    const hebrewMonths = [
        'ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני',
        'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'
    ];

    // Format date label based on the selected tab type
    const formatDateLabel = (criteria: { date_from: string; date_to: string }, selectedTab: number): string => {
        if (!criteria?.date_from) return '';
        
        const fromDate = new Date(criteria.date_from);
        const toDate = new Date(criteria.date_to);
        
        // Check for invalid dates
        if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
            return '';
        }
        
        switch (selectedTab) {
            case 0: // Day - dd/MM/yyyy
                return `${String(fromDate.getDate()).padStart(2, '0')}.${String(fromDate.getMonth() + 1).padStart(2, '0')}.${fromDate.getFullYear().toString().slice(-2)}`;
            
            case 1: // Week - dd/MM/yyyy - dd/MM/yyyy
                const fromStr = `${String(fromDate.getDate()).padStart(2, '0')}.${String(fromDate.getMonth() + 1).padStart(2, '0')}.${fromDate.getFullYear().toString().slice(-2)}`;
                const toStr = `${String(toDate.getDate()).padStart(2, '0')}.${String(toDate.getMonth() + 1).padStart(2, '0')}.${toDate.getFullYear().toString().slice(-2)}`;
                return `${toStr} - ${fromStr}`;
            
            case 2: // Month - Hebrew month name + year (e.g., אוגוסט 2025)
                return `${hebrewMonths[fromDate.getMonth()]} ${fromDate.getFullYear()}`;
            
            case 3: // Year - just year (e.g., 2025)
                return `${fromDate.getFullYear()}`;
            
            default:
                return '';
        }
    };

    const getDateLabels = () => {
        if (!compareCriteria?.criterias || compareCriteria.criterias.length < 2) {
            return { firstLabel: 'תאריך 1', secondLabel: 'תאריך 2' };
        }
        
        const firstCriteria = compareCriteria.criterias.find((c: { date_from: string; date_to: string; key: string }) => c.key === 'first');
        const secondCriteria = compareCriteria.criterias.find((c: { date_from: string; date_to: string; key: string }) => c.key === 'second');
        
        const firstLabel = firstCriteria ? formatDateLabel(firstCriteria, compareCriteria.selectedTab) : '';
        const secondLabel = secondCriteria ? formatDateLabel(secondCriteria, compareCriteria.selectedTab) : '';
        
        return {
            firstLabel: firstLabel || 'תאריך 1',
            secondLabel: secondLabel || 'תאריך 2',
        };
    };

    const dateLabels = getDateLabels();

  	const companyTableHeaders = [
		{
			Header: (
				<CustomHeaderContent mainText={i18nService.translate('repReports.tableHeader.mainTitle.companyName')} subText={i18nService.translate('repReports.tableHeader.subTitle.inSoftware')} />
			),
			accessor: 'companyName',
			isSortable: true,
			CustomCell: ({ cell, row }: { cell: any, row: any }) => (
				(
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							gap: 10,
						}}
					>
						<div
							style={{
								background: row.original.color,
								height: '8px',
								width: '8px',
								borderRadius: '20px',
							}}
						></div>
						<span
							style={{
								fontWeight:
									row.id === row.id ? 'bold' : 'normal',
								cursor: 'pointer',
							}}
						>
							{cell.value}
						</span>
					</div>
				)
			),
			Footer: () => (
						(
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									gap: 10,
								}}
							>
								<div
									style={{
										background: 'black',
										height: '8px',
										width: '8px',
										borderRadius: '20px',
									}}
								></div>
								<span
									style={{
										fontWeight: 'bold' ,
										cursor: 'pointer',
									}}
								>
									{i18nService.translate('general.total')}
								</span>
							</div>
						)
					),
		},
		{
			Header: (
				<CustomHeaderContent
					mainText={i18nService.translate('repReports.tableHeader.mainTitle.workingTime')}
					subText={i18nService.translate('repReports.tableHeader.subTitle.inSoftware')}
				/>
			),
			accessor: 'hours',
			isSortable: true,
			Footer: () => (
				<span style={{ fontWeight: 'bold' }}>{footerData.totalHours}</span>
			),
		},
		{
			Header: (
				<CustomHeaderContent
					mainText={i18nService.translate('repReports.tableHeader.mainTitle.payslips')}
					subText={i18nService.translate('repReports.tableHeader.subTitle.uploadedToPortal')}
				/>
			),
			accessor: 'payslipsUploaded',
			isSortable: true,
			Footer: () => (
				<span style={{ fontWeight: 'bold' }}>{footerData.totalPayslipsUploaded}</span>
			),
		},
		{
			Header: (
				<CustomHeaderContent
					mainText={i18nService.translate('repReports.tableHeader.mainTitle.forms101')}
					subText={i18nService.translate('repReports.tableHeader.subTitle.caredInPortal')}
				/>
			),
			accessor: 'forms101Processed',
			isSortable: true,
			Footer: () => (
				<span style={{ fontWeight: 'bold' }}>{footerData.totalForms101Processed}</span>
			),
		},,
	];

  	const compareClientTableHeader = [
		{
			Header: <CustomHeaderContent mainText={i18nService.translate('repReports.tableHeader.mainTitle.companyName')} subText='' customStyle={{alignItems: 'flex-start'}}/> ,
			accessor: 'a',
			isSortable: false,
			Cell: (cellProps: any) => (		
							<div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
								{cellProps.value}
							</div>
					),
			columns: [
				{
					Header: <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>{i18nService.translate('repReports.tableHeader.mainTitle.periodDistribution')}</div>,
					accessor: 'companyName',
					isSortable: false,
					style: { width: '25%'},
					Footer: () => (
									(
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												gap: 10,
											}}
										>
											<div
												style={{
													background: 'black',
													height: '8px',
													width: '8px',
													borderRadius: '20px',
												}}
											></div>
											<span
												style={{
													fontWeight: 'bold' ,
													cursor: 'pointer',
												}}
											>
												{i18nService.translate('general.total')}
											</span>
										</div>
									)
								),
					Cell: (cellProps: any) => (
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								gap: 10,
							}}
						>
							<div
								style={{
									background: cellProps.row.original.color,
									height: '8px',
									width: '8px',
									borderRadius: '20px',
								}}
							></div>
							<span>{cellProps.value}</span>
						</div>
					),
				},
			],
		},
		{
			Header: 
				<CustomHeaderContent
					mainText={i18nService.translate('repReports.tableHeader.mainTitle.workingTime')}
					subText={i18nService.translate('repReports.tableHeader.subTitle.inSoftware')}
				/>
,
			accessor: 'employeeId',
			isSortable: false,
			columns: [
				{
					Header: <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{dateLabels.firstLabel}</div>,
					accessor: 'firstWorkTime',
					isSortable: false,
					style: { width: '12.5%'},
					Footer: () => (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>{footerCompareData.firstTotalHours}</span>),
					Cell: (cellProps: any) => (

							<span style={{  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							{cellProps.value}
							</span>

					),
				},
				{
					Header: <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{dateLabels.secondLabel}</div>,
					accessor: 'secondWorkTime',
					isSortable: false,
					style: { width: '12.5%'},
					Footer: () => (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>{footerCompareData.secondTotalHours}</span>),
					Cell: (cellProps: any) => (

							<span style={{  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							{cellProps.value}
							</span>

					),
				},
			],
		},
		{
			Header: 
				<CustomHeaderContent
					mainText={i18nService.translate('repReports.tableHeader.mainTitle.payslips')}
					subText={i18nService.translate('repReports.tableHeader.subTitle.uploadedToPortal')}
				/>
			,
			accessor: 'department',
			isSortable: false,
			columns: [
				{
					Header: <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{dateLabels.firstLabel}</div>, // Second row header
					accessor: 'firstPaychecksUploaded',
					isSortable: false,
					style: { width: '12.5%'},
					Cell: (cellProps: any) => (

							<span style={{  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							{cellProps.value}
							</span>
					),
					Footer: () => (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>{footerCompareData.firstTotalPayslipsUploaded}</span>),

				},
				{
					Header: <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{dateLabels.secondLabel}</div>, // Second row header
					accessor: 'secondPaychecksUploaded',
					isSortable: false,
					style: { width: '12.5%'},
					Cell: (cellProps: any) => (

							<span style={{  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							{cellProps.value}
							</span>
					),
					Footer: () => (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>{footerCompareData.secondTotalPayslipsUploaded}</span>),
				},
			],
		},
		{
			Header: 
				<CustomHeaderContent
					mainText={i18nService.translate('repReports.tableHeader.mainTitle.forms101')}
					subText={i18nService.translate('repReports.tableHeader.subTitle.caredInPortal')}
				/>
			,
			accessor: 'hours',
			isSortable: false,
			columns: [
				{
					Header: <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{dateLabels.firstLabel}</div>, // Second row header
					accessor: 'firstForms101Processed',
					isSortable: false,
					style: { width: '12.5%'},
					Cell: (cellProps: any) => (

							<span style={{  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							{cellProps.value}
							</span>

					),
					Footer: () => (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>{footerCompareData.firstTotalForms101Processed}</span>),
				},
				{
					Header: <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{dateLabels.secondLabel}</div>, // Second row header
					accessor: 'secondForms101Processed',
					isSortable: false,
					style: { width: '12.5%'},
					Cell: (cellProps: any) => (

							<span style={{  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							{cellProps.value}
							</span>

					),
					Footer: () => (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>{footerCompareData.secondTotalForms101Processed}</span>),
				},
			],
		},
	];

    // Fetch initial data for current month on mount
    useEffect(() => {
        if (clientNumber) {
            console.log('Fetching initial data for current month:', currentMonth, 'year:', currentYear);
            dispatch(fetchClientWorkingTimeData({
                clientnumber: clientNumber,
				user_id: resolvedUserId,
                period: 'monthly',
                year: currentYear,
                month: currentMonth,
            }));

            const lastMonth = currentMonth === 1 ? 12 : currentMonth - 1;
            const lastMonthYear = currentMonth === 1 ? currentYear - 1 : currentYear;
          
            const initialCriterias = [
                {
                    date_from: `${currentYear}-${String(currentMonth).padStart(2, '0')}-01`,
                    date_to: `${currentYear}-${String(currentMonth).padStart(2, '0')}-31`,
                    key: 'first',
                },
                {
                    date_from: `${lastMonthYear}-${String(lastMonth).padStart(2, '0')}-01`,
                    date_to: `${lastMonthYear}-${String(lastMonth).padStart(2, '0')}-31`,
                    key: 'second',
                },
            ];

            // Set initial compareCriteria for date labels
            setCompareCriteria({
                period: 'monthly',
                criterias: initialCriterias,
                selectedTab: 2, // Month tab
            });

            dispatch(fetchClientCompareCompaniesData({
                period: 'monthly',
                clientnumber: clientNumber,
				user_id: resolvedUserId,
                criterias: initialCriterias,
                selectedTab: 2,
            }));
        }
    }, [clientNumber, dispatch, resetKey]);


	const handleGoBack = () => {
		if (navigation.canGoBack && navigation.canGoBack()) {
			navigation.goBack();
		} else {
			navigation.navigate('workingTimeReports');
		}
	};

	const handleCompaniesExcelExport = async () => {
	const dateStr = new Date().toLocaleString('en-IL', {hour12: false})
                   .replace(/, /g, '_') // Replace comma+space with underscore
                   .replaceAll('/', '-')
                   .replaceAll(':', '-')
                   .replaceAll(' ', '_');
		try {
			await exportToExcel( {
				fileName: `${i18nService.translate('repReports.workingTimeReports.timeAndDelivery.Company')}${" " + dateStr}.xlsx`,
				sheetName: 'Companies Working Time',
				title: i18nService.translate('repReports.workingTimeReports.timeAndDelivery.Company'),
				data: companiesExcelData,
				columns: [
					{
						header: i18nService.translate('repReports.companiesExcel.companyName'),
						key: 'companyName',
						width: 30,
					},
					{
						header: i18nService.translate('repReports.companiesExcel.workingTime'),
						key: 'workingTime',
						width: 30,
					},
					{
						header: i18nService.translate('repReports.companiesExcel.payslips'),
						key: 'payslipsUploaded',
						width: 30,
					},
					{
						header: i18nService.translate('repReports.companiesExcel.forms101'),
						key: 'forms101Processed',
						width: 30,
					},
				],
			});
		} catch (error) {
			setSnackbarOpen(true);
			setSnackbarMessage(i18nService.translate('excelToastError'));
		}
	}


  return (
    <>
        <WorkingTimeReportDetailComponent 
            route={route} 
            navigation={navigation} 
            id={id}
            data={data}
            compareData={compareData}
            clientNumber={clientNumber}
            miniCardsData={clientMiniCardData}
            barChartData={barChartData}
            companyTableHeaders={companyTableHeaders}
            companyTableData={companysTableData}
			handleExcel={handleCompaniesExcelExport}
            companyPieData={companyPieData}
            compareClientTableHeader={compareClientTableHeader}
            timeRangeOptions={timeRangeOptions}
			handleReset={handleReset}
            handleChange={handleChange}
            handleDateChange={handleDateChange}
            handleCompareData={handleCompareData}
            handleGoBack={handleGoBack}
            menuMode={menuMode}
            selectedPeriod={selectedPeriod}
            dateLabels={dateLabels}
            companyColorMapping={companyColorMapping}
            
        />
        <Snackbar 
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            open={snackbarOpen}
            autoHideDuration={4000}
            onClose={() => setSnackbarOpen(false)}
            ContentProps={{
                style: {
					direction: 'rtl',
                    backgroundColor: '#d32f2f',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    borderRadius: '4px',
                    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14)',
                }
            }}
            message={
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {snackbarMessage}
                </span>
            }
        />
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 8,
    paddingHorizontal: 32,
    overflow: 'scroll',
  }
});

export default WorkingTimeReportDetailContainer;